import { render, staticRenderFns } from "./RecordDrawer.vue?vue&type=template&id=d61b0b1a&scoped=true&"
import script from "./RecordDrawer.vue?vue&type=script&lang=js&"
export * from "./RecordDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RecordDrawer.vue?vue&type=style&index=0&id=d61b0b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61b0b1a",
  null
  
)

export default component.exports